import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Container,
  Avatar,
  Box,
  Breadcrumbs,
} from '@mui/material';
import { api } from '../services';

export const Profile = () => {
  const navigate = useNavigate();
  const [userInfos, setUserInfos] = useState(null);
  const [dataChashe, setDataChashe] = useState([]);
  const phoneNumber = localStorage.getItem('phoneNumber');
  const key = localStorage.getItem('key');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`Home/GetProfileInfo?SesID=${key}&OID=1`);
        let data = response.data;

        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (error) {
            console.error('Invalid JSON string:', data);
            return;
          }
        }

        if (data.ErrorMessage) {
          navigate('/login');
          return;
        }

        setDataChashe(data);
        const { Fname, Lname, Melicode, Birthdate, Gender } = data[0] || {};
        setUserInfos({ Fname, Lname, Melicode, Birthdate, Gender });
      } catch (error) {
        console.error('Error fetching profile info:', error);
        navigate('/login');
      }
    };
    fetchData();
  }, [key, navigate]);

  const exitUser = () => {
    localStorage.removeItem('phoneNumber');
    localStorage.removeItem('key');
    localStorage.removeItem('Fname');
    localStorage.removeItem('Lname');
    navigate('/');
  };

  const mainload = () => {
    navigate('/');
  };

  const historyPage = () => {
    navigate('/history');
  };

  const handelPayme = () => {
    navigate('/payment');
  };

  const handelUpload = () => {
    navigate('/uploadFiles');
  };

  const handelEditRow = () => {
    const { Fname, Lname, Melicode, Birthdate, Gender } = userInfos || {};
    navigate('/edirPro', { state: { l1: Fname, l2: Lname, l3: Melicode, l4: Birthdate, l5: Gender } });
  };

  const getGenderText = (gender) => {
    return gender === 1 ? 'مرد' : gender === 2 ? 'زن' : 'نامشخص';
  };

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      {/* <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 4 }}>
        <Link to="/" style={{ textDecoration: 'none', color: '#1976d2' }}>
          صفحه اصلی
        </Link>
        <Typography color="text.primary">پروفایل</Typography>
      </Breadcrumbs> */}

      <Grid container spacing={4} justifyContent="center">
        {/* Profile Image */}
        <Grid item xs={12} md={6}>
          <div className='card-body card p-3 shadow rounded-3 p-4 text-center' style={{ height: '100%' }}>
            <img
              src="Img/imguser.jpg"
              alt="Profile"
              style={{
                width: '100%',
                maxHeight: '340px',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </div>
        </Grid>

        {/* Profile Info */}
        <Grid item xs={12} md={6}>
          <div className='card-body card p-3 shadow rounded-3 p-4 text-center' style={{ height: '100%' }}>
            <Typography variant="h5" align="center" gutterBottom>
              پروفایل کاربر
            </Typography>
            {userInfos ? (
              <Box sx={{ mt: 2 }}>
                <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="text.secondary">
                    نام:
                  </Typography>
                  <Typography variant="body1" color="text.primary">
                    {userInfos.Fname || 'نامشخص'}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="text.secondary">
                    نام خانوادگی:
                  </Typography>
                  <Typography variant="body1" color="text.primary">
                    {userInfos.Lname || 'نامشخص'}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="text.secondary">
                    کد ملی:
                  </Typography>
                  <Typography variant="body1" color="text.primary">
                    {userInfos.Melicode || 'نامشخص'}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="text.secondary">
                    سال تولد:
                  </Typography>
                  <Typography variant="body1" color="text.primary">
                    {userInfos.Birthdate || 'نامشخص'}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="text.secondary">
                    جنسیت:
                  </Typography>
                  <Typography variant="body1" color="text.primary">
                    {getGenderText(userInfos.Gender)}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" color="text.secondary">
                    شماره موبایل:
                  </Typography>
                  <Typography variant="body1" color="text.primary">
                    {phoneNumber || 'نامشخص'}
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Typography color="text.secondary" align="center">
                در حال بارگذاری...
              </Typography>
            )}

            <Box sx={{ 
              mt: 4, 
              display: 'flex', 
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2, 
              justifyContent: 'center',
              alignItems: 'center',
              padding: '20px'
            }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  const dateSelected = localStorage.getItem("date_n");
                  const timeSelected = localStorage.getItem("time");
                  const doctorSelected = localStorage.getItem("doctor_id");
                  const loginSource = localStorage.getItem('loginSource');

                  const canContinuePayment =
                    loginSource === 'payment' &&
                    !!dateSelected && !!timeSelected && !!doctorSelected;

                  if (canContinuePayment) {
                    navigate('/Payment');
                  } else {
                    navigate('/');
                  }
                }}
                sx={{ 
                  minWidth: 200,
                  height: 45,
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4
                  }
                }}
              >
                {(() => {
                  const dateSelected = localStorage.getItem('date_n');
                  const timeSelected = localStorage.getItem('time');
                  const doctorSelected = localStorage.getItem('doctor_id');
                  const loginSource = localStorage.getItem('loginSource');
                  const canContinuePayment =
                    loginSource === 'payment' &&
                    !!dateSelected && !!timeSelected && !!doctorSelected;
                  return canContinuePayment ? 'ادامه پرداخت' : 'بازگشت به صفحه اصلی';
                })()}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate('/edirPro')}
                sx={{ 
                  minWidth: 200,
                  height: 45,
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  borderWidth: 2,
                  '&:hover': {
                    borderWidth: 2
                  }
                }}
              >
                ویرایش اطلاعات کاربری
              </Button>
            </Box>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};